module.exports = __webpack_public_path__ + "_assets/img/book01.81113d69.svg";